import axios from 'axios';

export function getStilstand(params) {
    return axios.get('/api/vehicles/stilstand', {params: params});
}

export function saveStilstand(stilstand) {
    return axios.post('/api/vehicles/stilstand', stilstand);
}

export function loadStandardReasons() {
    return axios.get('/api/vehicles/stilstand/reasons');
}

export function downloadStilstand(year) {
    const formData = new FormData();
    formData.append('year', year);

    return axios({
        method: 'post',
        responseType: 'arraybuffer',
        url: '/api/vehicles/stilstand-export',
        data: formData,
    });
}
